import React from 'react';
import { CRow, CCol, CCard, CCardBody, CForm, CFormSelect, CSpinner, CAlert } from '@coreui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarDays, faCalendarXmark, faCaretRight, faFileLines, faSquareCheck, faMoneyCheckDollar } from '@fortawesome/free-solid-svg-icons';

const CARD_WIDTH = 2;

const WelcomeCardItem = ({ title, icon, value }) => (
  <CCard className="h-100 shadow-sm">
    <CCardBody className="d-flex flex-column align-items-center">
      <div className="p-1 mb-1">
        <FontAwesomeIcon icon={icon} size="2x" className="text-primary" />
        <span className="text-center text-primary ms-3">{title}</span>
      </div>
      <h4 className="text-center font-weight-bold">{value}</h4>
    </CCardBody>
  </CCard>
);

const WelcomeView = ({ isLoading, error, licenses, selectedLicense, handleLicenseSelect }) => {

  return (
    <>
      <div className="text-center mb-4">
        <h3 className="text-primary">View your SDK license information</h3>
      </div>

      {error && (
        <CAlert color="danger">
          {error}
        </CAlert>
      )}

      {isLoading ? (
        <div className="text-center my-5">
          <CSpinner color="primary" />
        </div>
      ) : (
        <CRow>
          <CCol md={12} className="mb-4">
            <CForm>
              <CFormSelect 
                onChange={(e) => handleLicenseSelect(e.target.value)}
                label="Select License"
              >
                <option key={"license-0"} value={null}>
                  Please select the license.
                </option>
                {licenses.map(license => (
                  <option key={license.license_id} value={license.license_id}>
                    {license.license_key}
                  </option>
                ))}
              </CFormSelect>
            </CForm>
          </CCol>

          {selectedLicense  && (
            <>
              <CCol md={CARD_WIDTH}>
                <WelcomeCardItem
                  title="Number of Licenses"
                  icon={faCaretRight}
                  value={`${selectedLicense.number_of_licenses}`}
                />
              </CCol>
              <CCol md={CARD_WIDTH}>
                <WelcomeCardItem
                  title="Number of Licenses Used"
                  icon={faSquareCheck}
                  value={`${selectedLicense.number_of_licenses_used}`}
                />
              </CCol>
              
              <CCol md={CARD_WIDTH}>
                <WelcomeCardItem
                  title="Billing Type"
                  icon={faMoneyCheckDollar}
                  value={selectedLicense.billing_type}
                />
              </CCol>
              <CCol md={CARD_WIDTH}>
                <WelcomeCardItem
                  title="SDK Type"
                  icon={faFileLines}
                  value={selectedLicense.sdk_type}
                />
              </CCol>
              <CCol md={CARD_WIDTH}>
                <WelcomeCardItem
                  title="License"
                  icon={faCalendarDays}
                  value={selectedLicense.license_mode}
                />
              </CCol>
              <CCol md={CARD_WIDTH}>
                <WelcomeCardItem
                  title="Expiration Date"
                  icon={faCalendarXmark}
                  value={selectedLicense.expiration_date}
                />
              </CCol>
            </>
          )}
        </CRow>
      )}
    </>
  );
};

export default WelcomeView;